import { useEffect, useState } from 'react'
import Lib from 'library'

const useCommonIndustry = (initialValue) => {
	const [state, setState] = useState(initialValue)

	const getData = () => {
		Lib.get("/api/comm/cd/INDST", data => {
			setState(data)
		})
	}

	useEffect(() => {
		getData()
	}, [])

	return state
}

export default useCommonIndustry;
